<template>
  <v-list-group>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>Building Type</v-list-item-title>
      </v-list-item-content>
      <div v-if="buildingType.length > 0">
        <v-badge color="brown" :content="buildingType.length"> </v-badge>
      </div>
    </template>
    <v-list-item v-for="(list, i) in listBuildingType" :key="i">
      <v-checkbox
        v-model="buildingType"
        :label="list.name"
        @change="filterDataType('building_type', $event)"
        :value="list.value"
        hide-details
      >
      </v-checkbox>
    </v-list-item>
  </v-list-group>
</template>

<script>
import { EventBus } from "@/utils/eventBus";
import { debounce } from "@/utils/format";

export default {
  name: "NavigationBuildingType",
  data() {
    return {
      buildingType: [],
      listBuildingType: [
        {
          name: "Apartment",
          value: "Apartment"
        },
        {
          name: "Office",
          value: "Office"
        },
        {
          name: "Hotel",
          value: "Hotel"
        },
        {
          name: "Retail",
          value: "Retail"
        },
        {
          name: "Others",
          value: "Other"
        }
      ]
    };
  },
  created() {
    EventBus.$on("TYPE_RESET", value => {
      if (value == "reset") {
        this.buildingType = [];
      }
    });
  },
  methods: {
    filterDataType: debounce(function(type, data) {
      EventBus.$emit("TYPE_EVENT", { type, data });
    }, 1000)
  }
};
</script>
